

class BaseSequence {
  constructor(converter, pos, isOpening = true) {
    this.converter = converter
    this.pos = pos
    this.isOpening = isOpening
    this.link = null
  }
}

export default BaseSequence